class SectionTabs extends HTMLElement {
  constructor() {
    super();

    this.tabs = this.querySelectorAll('.section__tab-button');
    this.tabsContent = this.querySelectorAll('.section__tabs-content');
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        // Deactivate all tabs
        this.tabs.forEach((otherTab) => {
          otherTab.classList.remove('active');
        });
        
        // Activate clicked tab
        tab.classList.add('active');
        
        // Deactivate all tab contents
        this.tabsContent.forEach((tabContent) => {
          tabContent.classList.remove('show');
        });
        
        // Activate corresponding tab content
        const contentToActivate = document.getElementById(tab.dataset.id);
        if (contentToActivate) {
          contentToActivate.classList.add('show');
        }
      });
    });
  }
}

customElements.define('section-tabs', SectionTabs);

class SocialInteractions extends HTMLElement {
  constructor() {
    super();
    this.viewCount = Math.floor(Math.random() * (5000000 - 500 + 1)) + 500;
    this.likeCount = Math.floor(Math.random() * 500);
    this.dislikeCount = Math.floor(Math.random() * 200);
    this.handle = this.getAttribute('data-handle');
  }

  connectedCallback() {
    this.viewCountElement = this.querySelector('[data-views]');
    this.likeCountElement = this.querySelector('[data-like-count]');
    this.dislikeCountElement = this.querySelector('[data-dislike-count]');
    this.likeBtn = this.querySelector('[data-like]');
    this.dislikeBtn = this.querySelector('[data-dislike]');
    this.bookmarkIcon = this.querySelector('[data-bookmark]');

    this.init();
    this.updateButtonState();
    this.updateBookmarkState();

    this.likeBtn.addEventListener('click', () => this.handleLike());
    this.dislikeBtn.addEventListener('click', () => this.handleDislike());
    this.bookmarkIcon.addEventListener('click', () => this.handleBookmark());
  }

  formatNumber(num) {
    if (num >= 1000000) return (num / 1000000).toFixed(1) + 'M';
    if (num >= 1000) return (num / 1000).toFixed(1) + 'K';
    return num;
  }

  init() {
    this.viewCountElement.textContent = `${this.formatNumber(this.viewCount)}+ Views`;
    this.likeCountElement.textContent = this.formatNumber(this.likeCount);

    if (this.dislikeCountElement)
      this.dislikeCountElement.textContent = this.formatNumber(this.dislikeCount);
  }

  updateButtonState() {
    if (this.likeCount > 0) {
      this.dislikeBtn.disabled = true;
    } else if (this.dislikeCount > 0) {
      this.likeBtn.disabled = true;
    } else {
      this.likeBtn.disabled = false;
      this.dislikeBtn.disabled = false;
    }
  }

  updateBookmarkState() {
    if (!this.handle) return;
    
    const bookmarks = JSON.parse(localStorage.getItem('bookmarks') || '{}');
    if (bookmarks[this.handle]) {
        this.bookmarkIcon.classList.add('active');
    } else {
        this.bookmarkIcon.classList.remove('active');
    }
  }

  handleLike() {
    this.likeCount++;
    this.likeCountElement.textContent = this.formatNumber(this.likeCount);
    this.dislikeCount = Math.max(this.dislikeCount - 1, 0);
    if (this.dislikeCountElement) this.dislikeCountElement.textContent = this.formatNumber(this.dislikeCount);
    this.updateButtonState();
  }

  handleDislike() {
    this.dislikeCount++;
    if (this.dislikeCountElement) this.dislikeCountElement.textContent = this.formatNumber(this.dislikeCount);
    this.likeCount = Math.max(this.likeCount - 1, 0);
    this.likeCountElement.textContent = this.formatNumber(this.likeCount);
    this.updateButtonState();
  }

  handleBookmark() {
    if (!this.handle) return;
    
    const bookmarks = JSON.parse(localStorage.getItem('bookmarks') || '{}');
    
    if (this.bookmarkIcon.classList.contains('active')) {
        this.bookmarkIcon.classList.remove('active');
        delete bookmarks[this.handle];
    } else {
        this.bookmarkIcon.classList.add('active');
        bookmarks[this.handle] = true;
    }
    
    localStorage.setItem('bookmarks', JSON.stringify(bookmarks));
  }
}

if (!customElements.get('social-interactions')) {
  customElements.define('social-interactions', SocialInteractions);
}

document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
  anchor.addEventListener("click", function (e) {
    const targetId = anchor.getAttribute('href').slice(1);
    if (targetId && targetId !== 'recover') {
      e.preventDefault();
      const targetElement = document.getElementById(targetId);
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  });
});

document.querySelectorAll('video').forEach((videoEl) => {
  videoEl.addEventListener('play', function() {
    if (videoEl.getAttribute('data-played') !== 'true') {
      videoEl.setAttribute('data-played', 'true');
    }
  });
});

document.querySelectorAll('.media__play-icon').forEach((mediaPlay) => {
  mediaPlay.addEventListener('click', function() {
    mediaPlay.classList.add('hidden');

    const video = this.closest('.media')?.querySelector('video');
    if (video) {
      video.setAttribute('data-played', 'true');
      video.play();
    }
  });
});

function copyDiscountCode(button) {
  // Get the discount code from data-text attribute
  const discountCode = button.getAttribute('data-text');
  
  // Copy to clipboard
  navigator.clipboard.writeText(discountCode).then(() => {
    // Find the tooltip span element
    const tooltip = button.querySelector('.tooltip');
    if (!tooltip) return;
    
    // Change tooltip text to "Copied!"
    tooltip.textContent = 'Copied!';
    
    // Reset tooltip text after 2 seconds
    setTimeout(() => {
      tooltip.textContent = 'Copy';
    }, 2000);
  }).catch(err => {
    console.error('Failed to copy: ', err);
  });
}

function openColorDrawer() {
  // Inline colour selector: scroll it into view instead of opening a drawer.
  const inlineSelector = document.querySelector('colour-selector-inline');
  if (inlineSelector) {
    inlineSelector.scrollIntoView({ behavior: 'smooth', block: 'center' });
    return;
  }

  const drawerOpener = 
    document.querySelector('.drawer-opener') || 
    document.querySelector('.colour-drawer-button') ||
    document.querySelector('[data-open-colour-drawer]');
    
  if (drawerOpener) {
    drawerOpener.click();
  }
}

function initColorDrawerLinks() {
  document.querySelectorAll('a[data-choose-colour="true"]').forEach(link => {
    link.addEventListener('click', function(event) {
      event.preventDefault();
      
      const linkUrl = new URL(this.href, window.location.origin);
      const currentUrl = new URL(window.location.href);
      
      if (linkUrl.pathname === currentUrl.pathname) {
        openColorDrawer();
      } else {
        sessionStorage.setItem('openColourDrawer', 'true');
        window.location.href = this.href;
      }
    });
  });
}

function checkColorDrawerOpen() {
  if (sessionStorage.getItem('openColourDrawer') === 'true') {
    sessionStorage.removeItem('openColourDrawer');
    setTimeout(() => {
      openColorDrawer();
    }, 500);
  }
}
document.addEventListener('DOMContentLoaded', function() {
  initColorDrawerLinks();
  checkColorDrawerOpen();
  document.addEventListener('shopify:section:load', initColorDrawerLinks);
});

const scrollToEls = document.querySelectorAll('[data-scroll-link]');
scrollToEls.forEach(scrollToEl => {
  scrollToEl.addEventListener('click', function (e) {
    e.preventDefault();

    const targetId = scrollToEl.getAttribute('data-scroll-link');
    const targetEl = document.getElementById(targetId);

    if (!targetEl) return;

    if (scrollToEl.closest('details')) {
      scrollToEl.closest('details').open = false;
    }

    let headerHeight = 0;
    document.querySelectorAll('.shopify-section-group-header-group').forEach(header => {
      headerHeight += header.offsetHeight;
    });

    let scrollGap = 24;
    if (window.matchMedia('(max-width: 989px)').matches) {
      scrollGap = 100;
    }

    const targetPosition =
      targetEl.getBoundingClientRect().top + window.pageYOffset - headerHeight - scrollGap;

    console.log(targetPosition);

    window.scrollTo({
      top: targetPosition,
      behavior: 'smooth'
    });
  });
});